export default __webpack_public_path__ + "static/media/app_match_summary-private-match.0dfd27e7.jpg";